//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getHasMultiHandleInstagramEnabled } from '@account-settings/redux/facebook-instagram/selectors/getMultiHandleFeature';
import { ICuralateStore } from '@models/AppState';

export const getInstagramAccount = (state: ICuralateStore) =>
  state.instagram.account;

const getFacebookInstagramSettings = (state: ICuralateStore) =>
  state.facebookInstagramSettings;

export const getDefaultInstagramAccount = createSelector(
  getInstagramAccount,
  (igAccount) => igAccount.defaultInstagramAccount,
);

export const getFacebookInstagramSettingsFlags = createSelector(
  getFacebookInstagramSettings,
  (settings) => settings.flags,
);

export const getInstagramConnectionData = createSelector(
  getFacebookInstagramSettings,
  getFacebookInstagramSettingsFlags,
  getHasMultiHandleInstagramEnabled,
  (
    {
      connectedInstagramAccount,
      connectedInstagramAccounts,
      facebookUserToken,
    },
    { isFetchingConnectedInstagramAccount, isFetchingFacebookUserToken },
    hasMultiHandleInstagramEnabled,
  ) => {
    const defaultConnectedInstagramAccount = hasMultiHandleInstagramEnabled
      ? connectedInstagramAccounts?.find((account) => account.isDefault)
      : connectedInstagramAccount;

    return {
      connectedInstagramAccount: defaultConnectedInstagramAccount,
      facebookUserToken,
      isFetchingConnectedInstagramAccount,
      isFetchingFacebookUserToken,
    };
  },
);
